export enum RaceOptionId {
  AMERICAN_INDIAN_ALASKA_NATIVE = 'american_indian_alaska_native',
  ASIAN = 'asian',
  BLACK_AFRICAN_AMERICAN = 'black_african_american',
  NATIVE_HAWAIIAN_OTHER_PACIFIC_ISLANDER = 'native_hawaiian_other_pacific_islander',
  OTHER_RACE = 'other_race',
  PREFER_NOT_ANSWER = 'prefer_not_answer',
  UNKNOWN = 'unknown',
  WHITE = 'white',
}
